import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/challenge/confirmation',
    name: 'Challenge Confirmation',
    component: () => import('../views/Confirmation.vue')
  },
  {
    path: '/challenge/:slug?',
    name: 'Challenge',
    component: () => import('../views/Challenge.vue')
  },
  {
    path: '/challenge/:slug?/confirmation',
    name: 'Custom Challenge Confirmation',
    component: () => import('../views/Confirmation.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    meta: { requiresAuth: true },
    component: () => import('../views/Profile.vue'),
    beforeEnter: async (to, from, next) => {
      // Auth is required on this route!

      const { token } = to.query
      if (token) {
        await store.dispatch('getUser', token).catch(() => {})
      }
      return next()
    },
    children: [
      {
        path: 'info',
        name: 'Info',
        component: () => import('@components/profile/info.vue')
      },
      {
        path: 'subscription',
        name: 'Subscription',
        component: () => import('@components/profile/subscription.vue')
      },
      {
        path: 'password',
        name: 'Password',
        component: () => import('@components/profile/password.vue')
      },
      {
        path: 'purchases',
        name: 'Purchases',
        component: () => import('@components/profile/purchases.vue')
      }
    ]
  },
  {
    path: '/confirmation',
    name: 'Subscribtion Confirmation',
    component: () => import('../views/Confirmation.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('../components/Privacy.vue')
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('../components/Privacy.vue')
  },
  {
    path: '/tos',
    name: 'Tos',
    component: () => import('../components/Tos.vue')
  },
  {
    path: '/terms-of-use',
    name: 'TermsOfUse',
    component: () => import('../components/Tos.vue')
  },
  { path: '*', component: () => import('../views/Page.vue') }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// const DEFAULT_TITLE = process.env.VUE_APP_TRAINER_NAME
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    // Check store for page matches to write title
    if (to.path === '/') {
      document.title = `Home | ${process.env.VUE_APP_TRAINER_NAME}`
    } else if (to.path.includes('/challenge')) {
      if (store.state.activeChallengePage && store.state.activeChallengePage.pageName) {
        document.title = `${store.state.activeChallengePage.pageName} | ${process.env.VUE_APP_TRAINER_NAME}`
      } else {
        document.title = `Challenge | ${process.env.VUE_APP_TRAINER_NAME}`
      }
    } else if (to.path.includes('/profile')) {
      document.title = `Profile | ${process.env.VUE_APP_TRAINER_NAME}`
    } else if (to.path.includes('/confirmation')) {
      document.title = `Confirmation | ${process.env.VUE_APP_TRAINER_NAME}`
    } else if (store.state.activePage && store.state.activePage.pageName) {
      document.title = `${store.state.activePage.pageName} | ${process.env.VUE_APP_TRAINER_NAME}`
    } else {
      document.title = process.env.VUE_APP_TRAINER_NAME
    }
  })
})

export default router
